import GoogleIcon from '@mui/icons-material/Google';
import { Button } from '@mui/material';
import { useState } from 'react';
import { GoogleLogin } from 'react-google-login';
import { LOGON_METHOD } from '../../components/entities/sys-constants';
import IUser from '../../components/entities/user';
import { clearUser, setUser } from '../../redux/slices/user';
import { store } from '../../redux/store';

import { registerUser, setCredentials } from './auth.service';

const webClientId = '1088507409935-io8bpmu2ofgmdd6hcbo74g830eu2oqab.apps.googleusercontent.com';

export default function SignInWithGoogle(onSuccess: any) {
    const SCOPE = 'https://www.googleapis.com/auth/userinfo.profile';

    const [isSignedIn, setIsSignedIn] = useState(false);
    const [loading, setLoading] = useState('Loading...');

    async function getUserInfo(u: any) {
        const loginUser = {
            userId: u.googleId,
            email: u.email,
            userName: u.name,
            photoUrl: u.imageUrl,
            logonMethod: LOGON_METHOD.GOOGLE,
            password: 'temp@123',
            accountType: 1
        };
        await registerUser(loginUser)
            .then((res: any) => {
                if (res.status === 'Failed') {
                } else {
                    const authResponse = res.payload;

                    setCredentials({
                        accessToken: authResponse.accessToken,
                        refreshToken: authResponse.refreshToken
                    });

                    const appUser: IUser = {
                        accountType: 0
                    };

                    appUser.id = authResponse.id;
                    appUser.email = loginUser.email;
                    appUser.userName = authResponse.userName;
                    appUser.firstName = authResponse.firstName;
                    appUser.lastName = authResponse.lastName;
                    appUser.logonMethod = LOGON_METHOD.GOOGLE;
                    appUser.accessToken = authResponse.accessToken;
                    appUser.refreshToken = authResponse.refreshToken;
                    appUser.userId = u.id;

                    appUser.gender = res.payload.gender;
                    appUser.address = res.payload.address;
                    appUser.photoUrl = res.payload.photoUrl;
                    appUser.phoneNumber = res.payload.phoneNumber;
                    appUser.telegramNumber = res.payload.telegramNumber;
                    appUser.whatsappNumber = res.payload.whatsappNumber;

                    appUser.companyAddress = res.payload.companyAddress;
                    appUser.companyFacebook = res.payload.companyFacebook;
                    appUser.companyLinkedin = res.payload.companyLinkedin;
                    appUser.companyMobile = res.payload.companyMobile;
                    appUser.companyName = res.payload.companyName;
                    appUser.companyWebSite = res.payload.companyWebSite;
                    appUser.companyYoutube = res.payload.companyYoutube;
                    appUser.accountType = res.payload.accountType;

                    //sessionStorage.setItem('UserInfo', JSON.stringify(appUser));
                    store.dispatch(setUser(appUser));
                    // window.location.href = '/';
                }
            })
            .catch(async (e) => {
            });
    }

    const signOutHandler = () => {
        setIsSignedIn(false);
        googleSignOut();
    };
    const signInHandler = async (response: any) => {
        await getUserInfo(response.profileObj).then(() => {
            setIsSignedIn(true);
        });
    };

    const handleLoginFailure = (error: any) => {
        setLoading('');
    };

    const handleRequest = () => {
        setLoading('Loading...');
    };

    const handleAutoLoadFinished = () => {
        setLoading('');
    };

    return (
        <GoogleLogin
            clientId={webClientId}
            buttonText="Login"
            onSuccess={signInHandler}
            onFailure={handleLoginFailure}
            //cookiePolicy={'single_host_origin'}
            isSignedIn={isSignedIn}
            scope={SCOPE}
            onRequest={handleRequest}
            onAutoLoadFinished={handleAutoLoadFinished}
            render={(renderProps) => (
                <Button startIcon={<GoogleIcon sx={{ color: '#DB4437' }} />} variant="outlined" fullWidth sx={{ color: 'text.primary' }} onClick={renderProps.onClick}>
                    Google
                </Button>
            )}
        />
    );
}

export async function googleSignOut() {
    store.dispatch(clearUser());
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('UserInfo');
}
